import { combineReducers } from "redux";

// reducers
import app from "./app";
import api from "./api";
import filters from "./filters";
import labels from "./labels";
import parts from "./parts";
import qs from "./quick-search";
import table from "./table";
import tools from "./tools";
import modal from "./modal";
import myanalog from "./myanalog";
import promoBanner from './promoBanner';

export default combineReducers({
  app,
  api,
  filters,
  labels,
  parts,
  qs,
  table,
  tools,
  modal,
  myanalog,
  promoBanner
});
